import { Component, OnInit, Output } from '@angular/core';
import { PropertyTaxService } from 'src/app/services/propertyTax.service';
import { TasDataSource } from 'src/app/services/tasGovTable.datasource';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Card } from './card-utilities/card.model'
import { CARDS } from './card-utilities/cards.data';

@Component({
  selector: 'app-property-dashboard',
  templateUrl: './property-dashboard.component.html',
  styleUrls: ['./property-dashboard.component.css']
})
export class PropertyDashboardComponent implements OnInit {
  currentFilter = {}
  dataSource: TasDataSource;
  cards: Card[] = CARDS.map(c => ({ ...c, data: 0 }));   
  @Output() type: string;
  loading = { inProgress: false, downloadInProgress: false }
  constructor(private propertyTaxService: PropertyTaxService, 
    private router: Router,
    public dialog: MatDialog) { }

  ngOnInit(): void {}

  async loadPropertyTaxTable() {

    let attempt = 0;
    let result: any;

    while (attempt < 2) {
      try {
        attempt++;
        result = await this.propertyTaxService
          .getTableData(
            'property-tax/dashboard',
            '',
            '',
            '',
            0,
            1,
            this.currentFilter
          )
          .toPromise();

        if (result && !result.error) {
          const row = result.records && result.records[0];

          if (row) {
            this.cards = this.cards.map(card => ({
              ...card,
              data: row[card.field] ?? 0
            }));
          } else {
            this.cards = this.cards.map(card => ({ ...card, data: 0 }));
          }

          break; 
        } else {
          continue;
        }
      } catch (err) {
        if (err.name !== 'TimeoutError' || attempt >= 2) {
          console.error('Fetch failed:', err);
          this.cards = this.cards.map(card => ({ ...card, data: 0 }));
          break;
        }
      }
    }
  }
  
  advancedSearch(val) {
    this.currentFilter = val
    if (!this.currentFilter['municipality'] && localStorage.getItem('municipality')) {
      this.currentFilter['municipality'] = [localStorage.getItem('municipality')]
    }
    this.loadPropertyTaxTable()
  }

  reset() {
    this.currentFilter = {};
    this.cards = this.cards.map(card => ({ ...card, data: 0 }));
  }
}
